import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardLayout } from "@/components/DashboardLayout";
import { StatCard } from "@/components/StatCard";
import { getNav } from "@/lib/navConfig";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Inbox, AlertTriangle, UserX, Users, Calendar, FileText, CheckCircle2, Clock, Loader2, Receipt } from "lucide-react";

export default function DispatchDashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => { api.get("/dashboard/dispatch").then(({ data }) => setStats(data)); }, []);

  const cards = stats ? [
    { label: "New Requests", value: stats.new_requests, icon: Inbox, accent: "text-purple-600", f: "New" },
    { label: "Urgent", value: stats.urgent_requests, icon: AlertTriangle, accent: "text-rose-600" },
    { label: "Unassigned", value: stats.unassigned, icon: UserX, accent: "text-amber-600" },
    { label: "Assigned", value: stats.assigned, icon: Users, accent: "text-blue-600", f: "Contractor Assigned" },
    { label: "Scheduled", value: stats.scheduled, icon: Calendar, accent: "text-blue-600", f: "Scheduled" },
    { label: "Estimate Needed", value: stats.estimate_needed, icon: FileText, accent: "text-amber-600" },
    { label: "Awaiting Approval", value: stats.awaiting_approval, icon: Clock, accent: "text-amber-600", f: "Awaiting Client Approval" },
    { label: "In Progress", value: stats.in_progress, icon: Clock, accent: "text-indigo-600", f: "In Progress" },
    { label: "Completed", value: stats.completed, icon: CheckCircle2, accent: "text-emerald-600", f: "Completed" },
    { label: "Invoice Pending", value: stats.invoice_pending, icon: Receipt, accent: "text-teal-600", f: "Invoice Pending" },
  ] : [];

  return (
    <DashboardLayout nav={getNav(user.role)} title="Dispatch Board">
      {!stats ? <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-blue-600" /></div> : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {cards.map((c) => (
            <button key={c.label} data-testid={`dispatch-stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => navigate(`/app/dispatch/work-orders${c.f ? `?status=${encodeURIComponent(c.f)}` : ""}`)} className="text-left">
              <StatCard label={c.label} value={c.value} icon={c.icon} accent={c.accent} />
            </button>
          ))}
        </div>
      )}
    </DashboardLayout>
  );
}
